import HttpService from '@/shared/services/HttpService';
import {League} from '@/modules/create-league/types';

class CreateLeagueService {
    private http = new HttpService();
    public async fetchCompetitions() {
        try {
            const response = await this.http.get('ap/competitions');
            return response["hydra:member"].map((competition: any) => ({
                id: competition.id,
                name: competition.name,
            }));
        } catch (e) {
            return e;
        }
    }
    public async fetchSeries() {
        try {
            const response = await this.http.get('ap/series/');
            return response["hydra:member"]
        } catch (e) {
            return e
        }
    }
    public async createLeague(league: League) {
        try {
            await this.http.post('leagues', league);
        } catch (e) {
            throw e;
        }
    }
}

export default new CreateLeagueService();
